 import {Component, HostListener, EventEmitter, Inject, Input, OnInit, PLATFORM_ID, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {StorageService} from '../../../../core/services/storage.service';
import {AuthenticationService} from '../../../../core/services/authentication.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {PopupHelperService} from '../../../../core/services/popup-helper.service';
import {environment} from "@shared-environments/environment";
import {isPlatformBrowser, NgClass, NgIf} from "@angular/common";
import {WindowRef} from "../../../../core/helpers/windowRef.service";
import {TranslateModule} from "@ngx-translate/core";
import {CustomInputComponent} from "../../../../shared/components/custom-input/custom-input.component";
import {PrimaryButtonComponent} from "../../../../shared/components/primary-button/primary-button.component";
import {HttpService} from "../../../../core/services/http.service";
 import {IconModule} from "../../../../../../shared/assets/icons/ts/icon.module";
 import {InputPasswordComponent} from "@cybfed/ui-lib/forms/text-inputs/input-password/input-password.component";
 import {UserStore} from "@cybfed/core/store/user.store";
 import {ValidationErrorComponent} from "@cybfed/ui-lib/forms/validation-errors/validation-error.component";

@Component({
  selector: 'app-auth-signin-general',
  templateUrl: './auth-signin.component.html',
  standalone: true,
  imports: [
    TranslateModule,
    NgClass,
    ValidationErrorComponent,
    TranslateModule,
    IconModule,
    ReactiveFormsModule,
    InputPasswordComponent
  ],
  providers: [AuthenticationService, PopupHelperService, HttpService],
  styleUrls: ['./auth-signin.component.scss']
})
export class AuthSigninComponent implements OnInit {
  @Input() showBg = true;
  @Output() changeTub = new EventEmitter();
  @Output() closeModal = new EventEmitter();
  @Input() shouldRouting: boolean = true;

  loginForm: any;
  errorMessage: any;
  showLoginWithGoogle: boolean = true
  loginWithFacebookUrl: string = environment.apiURL + "/auth/facebook"
  loginWithVkUrl: string = environment.apiURL + "/auth/vk"
  loginWithSteamUrl: string = environment.apiURL + "/auth/steam"
  loginWithTwitchUrl: string = environment.apiURL + "/auth/twitch"
  loginWithGoogleUrl: string = environment.apiURL + "/auth/google"
  loginWithDiscordUrl: string = environment.apiURL + "/auth/discord"
  constructor(private formBuilder: FormBuilder,
              private authenticationService: AuthenticationService,
              private router: Router,
              private route: ActivatedRoute,
              private popupHelperService: PopupHelperService,
              public userStore: UserStore,
              @Inject(PLATFORM_ID) private platformId: any,
              private windowRef: WindowRef) {
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.minLength(2)]),
      password: ['', Validators.required]
    });

    const agent = (isPlatformBrowser(this.platformId))?this.windowRef.nativeWindow.navigator.userAgent:'';
    if(agent.indexOf('FBAN') !== -1 || agent.indexOf('FBAV') !== -1 || agent.indexOf('FBBV') !== -1 || agent.indexOf('FBID') !== -1){
      this.showLoginWithGoogle = false
    }
  }

  onSubmit(): any {
    const signinData = this.loginForm.value;
    if (this.loginForm.invalid){
      for (const key in this.loginForm.controls) {
        if (this.loginForm.controls[key].untouched && !this.loginForm.controls[key].value) {
          this.loginForm.controls[key].markAsTouched();
          this.loginForm.controls[key].setValue(1);
          this.loginForm.controls[key].setValue('');
        }
      }
      return false;
    }else{
      this.authenticationService.login({ username: signinData.email, password: signinData.password}).subscribe((data:any) => {
        if (!data.hasError) {
          StorageService.setJsonItem(StorageService.statics.currentUser, data.data.loginData);
          StorageService.setItem(StorageService.statics.token, data.data.loginData.token);
          let currentLang = StorageService.getItem(StorageService.statics.lang);
          if(this.showBg){
            if(currentLang !== data.data.loginData.language){
              StorageService.setItem(StorageService.statics.lang, data.data.loginData.language);
              StorageService.setItem(StorageService.statics.currency, data.data.loginData.currency);
              this.router.navigate(['/'])
                .then(() => {
                  if(isPlatformBrowser(this.platformId)) {
                    this.windowRef.nativeWindow.location.reload();
                  }
                });
            }else {
              this.router.navigate(['/']).then(() => {
                this.windowRef.nativeWindow.location.reload();
              });
            }
          }else{
            (isPlatformBrowser(this.platformId)) ? this.windowRef.nativeWindow.location.reload():'';
          }
        } else {
          this.errorMessage = data.errorMessages[0].msg;
          this.popupHelperService.printError({text:this.errorMessage});

        }
      });
    }
  }

  @HostListener('keydown.enter')
  handleKeyDown(event: KeyboardEvent) {
    this.onSubmit();
  }

  changeModalTub(){
    this.changeTub.emit('signup');
    if (this.shouldRouting) {
      this.router.navigate(['../signup'],{ relativeTo: this.route });
    }
  }


  forgotPassword(){
    this.router.navigate(['/auth/forgot-password'])
  }

}
